export default "__VITE_ASSET__BRMqzL2D__"